export interface SalaryBenefitsInput {
  enabledNps: boolean;
  employeeNps: number;
  employerNps: number;
  governmentEmployer: boolean;
  enabledMeals: boolean;
  mealCoupons: number;
  qualifyingMeals: boolean;
  workingDays: number;
  mealsPerDay: number;
}

// All amounts are monthly, independent of the calculator's display frequency.
export function calculateSalaryBenefits(
  input: SalaryBenefitsInput,
  specialAllowance: number,
  basicDa: number,
  regime: 'old' | 'new'
) {
  const positive = (value: number) => Number.isFinite(value) ? Math.max(0, value) : 0;
  const requestedEmployer = input.enabledNps ? positive(input.employerNps) : 0;
  const requestedMeals = input.enabledMeals ? positive(input.mealCoupons) : 0;
  // Allocate benefits within the existing CTC, preserving Basic, DA and HRA.
  const employer = Math.min(requestedEmployer, positive(specialAllowance));
  const meals = Math.min(requestedMeals, Math.max(0, specialAllowance - employer));
  const employerDeductionRate = regime === 'new' || input.governmentEmployer ? 14 : 10;
  const employerDeduction = Math.min(employer, positive(basicDa) * employerDeductionRate / 100);
  const mealLimit = 200 * Math.min(31, Math.floor(positive(input.workingDays)))
    * Math.floor(positive(input.mealsPerDay));

  return {
    employee: input.enabledNps ? positive(input.employeeNps) : 0,
    employer,
    employerDeduction,
    employerDeductionRate,
    meals,
    mealExemption: input.qualifyingMeals ? Math.min(meals, mealLimit) : 0,
    specialAllowance: Math.max(0, specialAllowance - employer - meals),
    allocationLimited: employer + meals < requestedEmployer + requestedMeals,
  };
}
